import { createApp } from "vue";
import { Modal } from "bootstrap";
import ConfirmModal from "@/components/modals/ConfirmModal.vue";

export function confirm(title, message, okText = "OK", cancelText = "Cancel") {
  return new Promise((resolve) => {
    // 1. Создаем контейнер
    const container = document.createElement('div');
    document.body.appendChild(container);

    // 2. Создаем Vue приложение
    const app = createApp({
      render() {
        return (
          <ConfirmModal
            title={title}
            message={message}
            ok={okText}
            cancel={cancelText}
            onConfirm={() => finish(true)}
            onCancel={() => finish(false)}
          />
        );
      }
    });

    // 3. Монтируем приложение
    app.mount(container);

    // 4. Функция завершения
    const finish = (result) => {
      // Получаем текущее модальное окно
      const modalElement = container.querySelector('.modal');
      const modalInstance = modalElement ? Modal.getInstance(modalElement) : null;

      // Удаляем слушатели событий первыми
      if (modalElement) {
        const modalEvents = ['hidden.bs.modal', 'hidePrevented.bs.modal'];
        modalEvents.forEach(event => {
          modalElement.removeEventListener(event, handleModalClose);
        });
      }

      // Закрываем модальное окно безопасно
      const safeHideModal = () => {
        try {
          if (modalInstance) {
            modalInstance.hide();
            modalInstance.dispose();
          }
        } catch (e) {
          console.warn('Modal hide error:', e);
        }
      };

      // Плавное закрытие с анимацией
      if (modalElement && modalElement.classList.contains('show')) {
        modalElement.addEventListener('transitionend', () => {
          cleanup();
        }, { once: true });
        safeHideModal();
      } else {
        cleanup();
      }

      function cleanup() {
        setTimeout(() => {
          app.unmount();
          container.remove();
          resolve(result);
        }, 100);
      }
    };

    // 5. Обработчик закрытия модального окна
    const handleModalClose = () => finish(false);

    // 6. Инициализация модального окна после рендера
    nextTick(() => {
      const modalElement = container.querySelector('.modal');
      if (modalElement) {
        // Удаляем предыдущий инстанс, если есть
        const existingInstance = Modal.getInstance(modalElement);
        if (existingInstance) {
          existingInstance.dispose();
        }

        // Создаем новое модальное окно
        const modalInstance = new Modal(modalElement, {
          backdrop: 'static',
          keyboard: false
        });

        modalElement.addEventListener('hidden.bs.modal', handleModalClose);
        modalInstance.show();
      }
    });
  });
}

// Вспомогательная функция nextTick
function nextTick(callback) {
  if (typeof Promise !== 'undefined') {
    Promise.resolve().then(callback);
  } else {
    setTimeout(callback, 0);
  }
}